import React from 'react'
const Helpandtipsbanner = () => {
    return (
        <div>
            <section className="page-header">
                <div className="page-header-bg"></div>
                <div className="container">
                    <div className="page-header__inner">
                        <div className="innerbanner">
                            <h4 className="text-custom-white no-margin">Help & Tips</h4>
                        </div>
                        <h6 className='para_absdasa'>Select Questions</h6>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Helpandtipsbanner